import { useState } from "react";
import { Link } from "react-router-dom";
import { apiJson } from "../../utils/api";
import useSeo from "../../hooks/useSeo";

const SPOTS = ["城市漫步", "景区约会", "酒店入住", "求婚场景", "模拟领证", "婚礼场地参观", "婚纱摄影", "蜜月旅行"];

export default function LoveTravel() {
  const [city, setCity] = useState("杭州市");
  const [selected, setSelected] = useState(["景区约会", "求婚场景", "模拟领证"]);
  const [saved, setSaved] = useState(null);

  useSeo({
    title: "爱情旅行 | 旅行中遇见爱情",
    metaDescription: "把城市、景区、求婚与模拟领证串成情侣旅行路线。",
    path: "/travel/love",
  });

  const toggle = (spot) => {
    setSelected((prev) => (prev.includes(spot) ? prev.filter((s) => s !== spot) : [...prev, spot]));
  };

  const save = async () => {
    const { data } = await apiJson("/api/travel/love/routes", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        city,
        title: `3天情侣旅行 + ${selected.join(" + ")}`,
        spots: selected,
        couple_code: localStorage.getItem("marriage_couple_code") || "",
      }),
    });
    setSaved(data);
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <p className="text-sm tracking-widest text-rose-500">旅行中遇见爱情</p>
      <h1 className="text-3xl font-extrabold">🌍 爱情旅行</h1>
      <p className="text-gray-600">
        旅行 → 认识 → 好感 → 情侣旅行 → AI情侣测试 → 模拟结婚 → 查询正式领证 → 婚礼。本页先帮你们串一条路线。
      </p>
      <input value={city} onChange={(e) => setCity(e.target.value)} className="border rounded-xl px-3 py-2 w-full" placeholder="城市" />
      <div className="flex flex-wrap gap-2">
        {SPOTS.map((spot) => (
          <button
            key={spot}
            type="button"
            onClick={() => toggle(spot)}
            className={`px-3 py-1.5 rounded-full text-sm border ${selected.includes(spot) ? "bg-rose-500 text-white border-rose-500" : "bg-white"}`}
          >
            {spot}
          </button>
        ))}
      </div>
      <div className="bg-white rounded-2xl p-5">
        <h2 className="font-bold mb-2">爱情旅行路线</h2>
        <p>
          {city} · 3天情侣旅行
          {selected.length ? ` + ${selected.join(" + ")}` : ""}
        </p>
      </div>
      <div className="flex flex-wrap gap-3">
        <button onClick={save} className="px-5 py-2 rounded-xl bg-rose-500 text-white">
          保存路线
        </button>
        <Link to="/travel/romantic-map" className="px-5 py-2 rounded-xl border">
          浪漫领证地图
        </Link>
        <Link to="/travel/impulse" className="px-5 py-2 rounded-xl border">
          旅行回来还是夫妻吗？
        </Link>
        <Link to="/wedding" className="px-5 py-2 rounded-xl border">
          婚礼 / 摄影 / 婚宴
        </Link>
      </div>
      {saved ? <p className="text-sm text-emerald-700">已保存：{saved.title}</p> : null}
    </div>
  );
}
